import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselIndicators',
  props: {
    slideNum: null,
    activeSlide: null
  },
  emits: ['update:active-slide'],
  setup(__props: any) {





return { __sfc: true, }
}

})